import React from 'react';
import CheckBoxGroup from '../Form/Compound/CheckBoxGroup';
import useFilterWrapper from '../../../hooks/generic/FilterUI/useFilterWrapper';
import { useDispatch } from '../../../chronusStore/helper';
import { safeMutate } from '../../../utils/GeneralUtils';
import { getLabelOrValueFromChoiceList } from './commonUtils';
import { getSelectedChoices } from '../Form/Compound/CheckBoxGroup/helper';

const CheckBoxFilter = ({
  dispatchActionFn, filterTitle,
  filterData, selectedValues,
  filterWrapperBodyClass = 'cui-events-filter-body',
  noHeaderShadow = false,
  initialFilterWrapperOptions = {},
  filterChangeHandler = undefined,
  newUx = true
}) => {
  const dispatch = useDispatch();
  const updatedFilterData = safeMutate(filterData, draftFilterData => {
    draftFilterData.forEach(choice => {
      if (selectedValues.includes(choice.value)) choice.checked = true;
    });
  });

  const onChangeHandler = (_event, _childUId, childData) => {
    const selectedValues = getLabelOrValueFromChoiceList(getSelectedChoices(childData))
    if (filterChangeHandler) filterChangeHandler(selectedValues);
    else dispatch(dispatchActionFn(selectedValues));
  };

  const [FilterWrapper, filterWrapperOptions, _filterWrapperActions] = useFilterWrapper(initialFilterWrapperOptions);
  const labelInfo = getLabelOrValueFromChoiceList(getSelectedChoices(updatedFilterData), { labelAndCount: true });

  return (
    <FilterWrapper
      title={ selectedValues.length ? filterTitle.withFilter : filterTitle.noFilter }
      currentValue={ labelInfo.label }
      filterCount={ labelInfo.count }
      bodyClass={ `cui-border-radius-6 ${filterWrapperBodyClass}` }
      headerWidthClass='custom-max-width-15'
      noHeaderShadow={ noHeaderShadow }
      newUx={ newUx }
      rounded={ !newUx }
      showFilter
      { ...filterWrapperOptions }
    >
      <CheckBoxGroup
        data={ updatedFilterData }
        onChange={ onChangeHandler }
        searchRef={ filterWrapperOptions.focusRef }
        renderSelectAllClear
        searchable
      />
    </FilterWrapper>
  )
}

export default CheckBoxFilter;